<div class="dates-selector-root relative fill grow" [class.separator]="!showSingular() && isOneway() === false">
  @if (!showSingular()) {
    <fin-booking-widget-selector
      [disabled]="disabled()"
      (click)="openModal()"
      [double]="
        isOneway() === false
          ? {
              first: {
                label: 'bookingSearch.boundSelection.departureDate' | finLocalization,
                placeholder: 'bookingSearch.boundSelection.selectDatePlaceholder' | finLocalization,
                filled: $safeNavigationMigration(travelDates()?.['departureDate']) !== undefined,
              },
              second: {
                label: 'bookingSearch.boundSelection.returnDate' | finLocalization,
                placeholder: 'bookingSearch.boundSelection.selectDatePlaceholder' | finLocalization,
                filled: $safeNavigationMigration(travelDates()?.['returnDate']) !== undefined,
              },
            }
          : undefined
      "
      [label]="'bookingSearch.boundSelection.departureDate' | finLocalization"
      [placeholder]="'bookingSearch.boundSelection.selectDatePlaceholder' | finLocalization"
      [filled]="$safeNavigationMigration(travelDates()?.['departureDate']) !== undefined"
      [attr.data-testid]="'travel-dates-selector-both'"
    >
      @if (isOneway() === true && travelDates()?.['departureDate']; as selectedDate) {
        <span data-testid="departure-date">{{ selectedDate | finDateFormat: 'FULL_NO_YEAR' }}</span>
      }
      @if (travelDates()?.['departureDate']; as selectedDate) {
        <span first data-testid="departure-date">{{ selectedDate | finDateFormat: 'FULL_NO_YEAR' }}</span>
      }
      @if (isOneway() === false && showSeparator()) {
        <div
          separator
          class="flex flex--center flex--self-center absolute white-bg surface-primary date-spacer ps-xxsmall z1"
        >
          <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.MINUS" />
        </div>
      }
      @if (travelDates()?.['returnDate']; as selectedDate) {
        <span second data-testid="return-date">{{ selectedDate | finDateFormat: 'FULL_NO_YEAR' }}</span>
      }
    </fin-booking-widget-selector>
  }
  @if (showSingular(); as departureOrReturn) {
    <fin-booking-widget-selector
      [disabled]="disabled()"
      (click)="openModal()"
      [label]="'bookingSearch.boundSelection.' + departureOrReturn | finLocalization"
      [placeholder]="'bookingSearch.boundSelection.selectDatePlaceholder' | finLocalization"
      [filled]="!!travelDates()?.[departureOrReturn]"
      [attr.data-testid]="'travel-dates-selector-' + departureOrReturn"
    >
      @if (travelDates()?.[departureOrReturn]; as selectedDate) {
        <span data-testid="departure-date">{{ selectedDate | finDateFormat: 'FULL_NO_YEAR' }}</span>
      }
    </fin-booking-widget-selector>
  }
</div>

<fcom-modal
  [open]="modalOpen$ | async"
  [fitToContent]="true"
  [buttons]="null"
  [fullHeight]="true"
  [extraWide]="true"
  [roundedContent]="true"
  (close)="closePriceCalendar()"
  data-testid="travel-dates-modal"
>
  @if (modalOpen$ | async) {
    <fin-price-calendar
      [openWithParams$]="priceCalendarParams$"
      [showAddReturn]="showAddReturn()"
      [showSubtitle]="showSubtitle()"
      [disabledDateRanges$]="disabledDateRanges$"
      [showFlexibleDatesSelection]="showFlexibleDatesSelection()"
      [showTripPriceFrom]="showTripPriceFrom()"
      [enableNewSearchAutomatically]="enableNewSearchAutomatically()"
      [isSearchEnabled]="isSearchEnabled()"
      [ctaLabel]="'actions.done' | finLocalization"
      [type]="priceCalendarType()"
      [enablePreFlightSearchTracking]="priceCalendarType() === PriceCalendarType.PRICES"
      (modalClose)="closePriceCalendar()"
      (ctaClicked)="priceCalendarCTAClicked($event)"
      (addReturnClicked)="addReturnClicked()"
      (travelDatesChanged)="travelDatesChanged($event)"
      (cancelSelection)="cancelSelection.emit()"
      (startSearch)="startSearch.emit()"
    />
  }
</fcom-modal>
